export default __webpack_public_path__ + "static/media/FulfillPickup.5af369ad.png";